import axios from 'axios';
import authService from './auth';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3060/api';

/**
 * 本地生成的导出（导游名单 PDF、团内 CSV）不经过服务器，生成后回报一条操作日志。
 * 留痕失败不影响导出本身，所以不 await、不提示。
 */
export function reportExport({ tourId, kind, tourists = [], page }) {
  if (!tourId) return;
  axios.post(`${API_BASE}/operation-logs/export-event`, {
    tourId,
    kind,
    count: tourists.length,
    tourists: tourists.map((t) => t.passportName || t.touristName || '').filter(Boolean),
    page,
  }, { headers: authService.getAuthHeaders() }).catch(() => {});
}
